

const  environment = 'production';
export const baseURL = environment === 'staging' 
? process.env.REACT_APP_API_STAGING_URL
: process.env.REACT_APP_API_URL